import req from 'utils/req';

export type Verification = {
  id: string;
  accountId: string;
  verificationType: string;
  item: string;
  submittedAt: Date;
  kycCheckProgress?: string;
  kycCheckResult?: string;
  verified: boolean;
};

const makePayload = (type: 'email' | 'phone', value: string) => {
  return type === 'email' ? { email: value } : { phoneNumber: value };
};

export async function getVerifications(
  accountId: string,
): Promise<Verification[]> {
  try {
    const response = await req(
      `${URL_API_HOST}/api/v1/account/verifications/${accountId}`,
    ).get();
    return response?.accountVerifications ?? [];
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function sendVerificationCode(
  accountId: string,
  type: 'email' | 'phone',
  value: string,
): Promise<Verification> {
  return await req(
    `${URL_API_HOST}/api/v1/account/${accountId}/verification/${type}`,
  ).post(makePayload(type, value));
}

export async function verifyCode(
  accountId: string,
  verificationId: string,
  code: string,
) {
  return await req(
    `${URL_API_HOST}/api/v1/account/${accountId}/verification/${verificationId}/code`,
  ).post({ code });
}

export async function createKycSdkToken(
  firstName: string,
  lastName: string,
  referer: string,
): Promise<string> {
  const response = await req(
    `${URL_API_HOST}/api/v1/services/kyc/sdk/token`,
  ).post({ firstName, lastName, referer });
  if (!!response && !!response.token) {
    return response.token;
  } else {
    return '';
  }
}

export async function completeKycVerification() {
  return await req(`${URL_API_HOST}/api/v2/services/kyc/completed`).put({});
}
